const React = require("react");
const { usePrintful } = require("../context/PrintfulContext");
const { useResource } = require("../hooks/useResource");
const { PageHeader, Button, ResourceState, Kpi, StatusBadge } = require("../components/ui");
const h = React.createElement;

const DropshippingAdmin = () => {
  const { api, t, isAdmin } = usePrintful();
  const resource = useResource(async () => ({
    ...(await api.getPlatform()),
    ...(await api.getAdminOverview()),
    ...(await api.getAdminConnections()),
  }), [api]);
  const [busy, setBusy] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState("");
  if (!isAdmin) return h("div", { className: "pfds-state" }, t("h_pf_admin_only", "Administration access required."));
  const overview = resource.data?.overview || {};
  const connections = resource.data?.connections || [];
  const platform = resource.data?.platform;
  const action = async (callback, success) => {
    setBusy(true); setMessage(""); setError("");
    try { await callback(); setMessage(success); await resource.reload(); }
    catch (requestError) { setError(requestError.message); }
    finally { setBusy(false); }
  };
  return h(React.Fragment, null,
    h(PageHeader, {
      title: t("h_pf_admin_title", "Printful administration"),
      action: h("div", { className: "pfds-row" },
        h(Button, { disabled: busy, variant: platform?.status === "active" ? "danger" : "", onClick: () => action(() => api.updateAdminPlatform({ status: platform?.status === "active" ? "inactive" : "active" }), t("h_pf_platform_updated", "Printful platform status updated.")) }, platform?.status === "active" ? t("h_pf_disable", "Disable Printful") : t("h_pf_enable", "Enable Printful")),
        h(Button, { disabled: busy, variant: "secondary", onClick: () => action(api.syncAllSellers, t("h_pf_admin_sync_done", "All active Printful sellers were synchronized.")) }, t("h_pf_sync_all_sellers", "Sync all sellers"))
      ),
    }),
    message ? h("div", { className: "pfds-success" }, message) : null,
    error ? h("div", { className: "pfds-alert" }, error) : null,
    h(ResourceState, { loading: resource.loading, error: resource.error, empty: false, reload: resource.reload, t },
      h(React.Fragment, null,
        h("div", { className: "pfds-kpis" },
          h(Kpi, { value: overview.connections || 0, label: t("h_pf_connections", "Connections") }),
          h(Kpi, { value: overview.products || 0, label: t("h_pf_products", "Products") }),
          h(Kpi, { value: overview.orders || 0, label: t("h_pf_orders", "Orders") }),
          h(Kpi, { value: overview.errors || 0, label: t("h_pf_errors", "Errors") })
        ),
        h("div", { className: "pfds-table-wrap" }, h("table", { className: "pfds-table" },
          h("thead", null, h("tr", null, h("th", null, t("h_pf_seller", "Seller")), h("th", null, t("h_pf_store", "Store")), h("th", null, t("h_pf_status", "Status")))),
          h("tbody", null, ...connections.map((connection) => h("tr", { key: connection._id },
            h("td", null, connection.sellerId?.email || connection.sellerId?._id),
            h("td", null, connection.storeName || connection.externalStoreId || "—"),
            h("td", null, h(StatusBadge, { status: connection.status, t }))
          )))
        ))
      )
    )
  );
};

module.exports = { DropshippingAdmin };
